module.exports = __webpack_public_path__ + "static/media/scan.b6ee4962.svg";